<template>
  <Card class="contract-decline" tag="form" @submit.prevent="submit">
    <template #default>
      <InputComponent v-model="reason" type="textarea" :label="$t('reason')" required>
        <template #below>
          <Alert class="mt-1">{{ $t('reasonWillBeSentToApplicants') }}</Alert>
        </template>
      </InputComponent>
    </template>
    <template #footer>
      <ButtonComponent :label="$t('cancel')" :icon="['fal', 'times']" @click="$emit('cancel')" />
      <ButtonComponent
        :disabled="!validator.passes"
        :label="$t('decline')"
        :promise="promise"
        @onSuccess="$emit('declined')"
        theme="error"
        type="submit"
        :icon="['fal', 'arrow-to-right']"
      />
    </template>
  </Card>
</template>

<script>
import API from '@/api/Contract'
import Validator from '@/mixins/validator-v2'

import Card from '@/components/Card'
import { InputComponent } from 'vue-elder-input'
import { AlertComponent as Alert } from 'vue-elder-alert'

export default {
  mixins: [
    Validator({
      rules: 'rules',
      data: 'dataComp',
    }),
  ],
  props: {
    value: Object,
  },
  data() {
    return {
      reason: null,
      promise: null,
    }
  },
  computed: {
    dataComp() {
      return {
        reason: this.reason,
      }
    },
    rules() {
      return {
        reason: 'required',
      }
    },
  },
  methods: {
    submit() {
      this.promise = API.decline({ id: this.value.id, message: this.reason })
    },
  },
  mounted() {
    this.$el.closest('.view').scrollIntoView({ behavior: 'smooth' })
  },
  components: {
    Card,
    InputComponent,
    Alert,
  },
}
</script>

<style lang="scss">
.contract-decline {
  .elder-button--error {
    &:disabled {
      color: var(--vue-elder-button-disabled-contrast, #737373) !important;
      border-color: var(--vue-elder-button-disabled, #ccc) !important;
      background-color: var(--vue-elder-button-disabled, #ccc) !important;
    }
  }
}
</style>
